<template>
<el-container>
<el-header class="header">
<el-breadcrumb separator-class="el-icon-arrow-right">
    <el-breadcrumb-item :to="{ path: '/' }" style="font-size: 16px;">Home</el-breadcrumb-item>
    <el-breadcrumb-item style="font-size: 16px;">Analysis</el-breadcrumb-item>
    <el-breadcrumb-item style="font-size: 16px;">Expression of Genes</el-breadcrumb-item>
</el-breadcrumb>
</el-header>
<el-aside width="3px"></el-aside>
<el-main>
<el-container>
    <el-aside class="aside">
    <div>
        <Vsgeneselect @search="handleSearch" />
    </div>
    </el-aside>
    <el-main>
        <div>
            <Tpmexpr :species="selectedSpecies" :tissue="selectedTissue" :key="selectedSpecies + selectedTissue" />
        </div>
        <div>
            <Singlegene :species="selectedSpecies" :tissue="selectedTissue" :key="selectedSpecies + selectedTissue" />
        </div>
    </el-main>
</el-container>
</el-main>
<el-aside width="3px"></el-aside>
</el-container>
</template>

<script>
import Vsgeneselect from '../Vsgene/Vsgeneselect.vue';
import Tpmexpr from '../comparison/Tpmexpr.vue';
import Singlegene from '../comparison/Singlegene.vue';


export default {
    components: {
        Vsgeneselect,Tpmexpr,Singlegene
    },
    data() {
        return {
            selectedSpecies: '',
            selectedTissue: [],
        };
    },
    created() {
        this.selectedSpecies = 'human';
        this.selectedTissue = ['ESC','PreME','ME',];
    },
    methods: {
        handleSearch(params) {
            this.selectedSpecies = params.Species;
            this.selectedTissue = params.Tissue;
        }
    }
};
</script>

<style scoped>
.header {
    padding: 0px;
    border-bottom: 1px solid #ccc;
    height: 40px;
    display: flex;
    align-items: center;
    margin-left: 20px;
    margin-top: 60px;
}
.aside {
    width: 240px;
    border-right: 1px dashed #ccc;
}
</style>


// WEBPACK FOOTER //
// src/components/analysis/Vsgene.vue